import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";
import { translations } from "../lib/i18n";

const AppCtx = createContext(null);

export function AppProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=logged out, object=logged in
  const [lang, setLang] = useState(localStorage.getItem("cr_lang") || "en");
  const [currency, setCurrency] = useState(localStorage.getItem("cr_currency") || "USD");

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  useEffect(() => localStorage.setItem("cr_lang", lang), [lang]);
  useEffect(() => localStorage.setItem("cr_currency", currency), [currency]);

  const t = useCallback((key) => translations[lang][key] ?? key, [lang]);
  const fmt = useCallback(
    (n) =>
      new Intl.NumberFormat(currency === "USD" ? "en-US" : "pt-BR", {
        style: "currency",
        currency: currency === "USD" ? "USD" : "BRL",
      }).format(n || 0),
    [currency]
  );

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(false);
  };

  return (
    <AppCtx.Provider value={{ user, setUser, lang, setLang, currency, setCurrency, t, fmt, logout }}>
      {children}
    </AppCtx.Provider>
  );
}

export const useApp = () => useContext(AppCtx);
